module.exports = __webpack_public_path__ + "img/top-banner.75260f6.png";